/** API route map: URLS.Controller.ClientBranch */
export const ClientBranch = {
      Name: 'ClientBranch/',
      GetAll: 'getall-client-branches',
      Add: 'add',
      DeleteBranch: 'delete',
      Update: 'update',
};
